export const LEARNER_ASSESSMENT_MODAL_SUBTITLE =
  'Help us understand how each learner thinks, stays motivated, and responds to challenges so we can match them more effectively.';

export const LEARNER_ASSESSMENT_QUESTIONS = [
  {
    id: 1,
    prompt:
      'When you begin learning something new, where does your attention go first?',
    options: [
      {
        key: 'a',
        text: 'I like to step back and think quietly before trying anything new; sometimes I test it with an example.',
      },
      {
        key: 'b',
        text: 'I jump in and try out different ideas on my own by experimenting and seeing what sticks.',
      },
      {
        key: 'c',
        text: 'Finding a clear plan from someone who has done it before, so I know exactly what I am getting into.',
      },
      {
        key: 'd',
        text: 'I explore new ideas with others, bouncing thoughts off them to see what fits.',
      },
      {
        key: 'e',
        text: 'I like to map out my own step-by-step plan before I start, so I know exactly how I want to tackle it.',
      },
    ],
  },
  {
    id: 2,
    prompt: 'If something is confusing, what do you usually do?',
    options: [
      { key: 'a', text: 'I replay it in my head until it makes sense.' },
      {
        key: 'b',
        text: 'I double-check that I’m doing it the right way before I continue.',
      },
      { key: 'c', text: 'I see how others are thinking about it.' },
      { key: 'd', text: 'I look for the rule or pattern behind it.' },
      {
        key: 'e',
        text: 'I try a few different approaches and see what works.',
      },
    ],
  },
  {
    id: 3,
    prompt: 'What helps you stay motivated while learning?',
    options: [
      {
        key: 'a',
        text: 'Talking things through with someone keeps me motivated.',
      },
      {
        key: 'b',
        text: 'Checking things off step-by-step gives me small wins that keep me motivated.',
      },
      {
        key: 'c',
        text: 'When it finally clicks in my mind, I feel driven to keep going.',
      },
      {
        key: 'd',
        text: 'Having the freedom to explore and discover on my own keeps me energized.',
      },
      {
        key: 'e',
        text: 'Knowing I’m on the right track keeps me motivated.',
      },
    ],
  },
  {
    id: 4,
    prompt: 'How do you feel when you make a mistake?',
    options: [
      {
        key: 'a',
        text: 'I feel uneasy at first, but sharing my frustration helps me get past it.',
      },
      {
        key: 'b',
        text: 'I feel annoyed at making the mistake, but it gets better once I map out the corrections.',
      },
      {
        key: 'c',
        text: 'I feel disappointed at first, but thinking it through helps me regain confidence.',
      },
      {
        key: 'd',
        text: 'I feel a little anxious, but I try to carefully check what went wrong.',
      },
      {
        key: 'e',
        text: 'I feel self conscious, but I’m determined to explore another path.',
      },
    ],
  },
  {
    id: 5,
    prompt: 'When you have a long-term goal, what do you enjoy most?',
    options: [
      {
        key: 'a',
        text: 'I enjoy seeing how steady, organized effort over time leads to success.',
      },
      {
        key: 'b',
        text: 'I feel energized watching my progress grow over time as I try new strategies.',
      },
      {
        key: 'c',
        text: 'I love having the time to carefully work through things and get them right.',
      },
      {
        key: 'd',
        text: 'I feel motivated by the changes I notice in myself over time as I work toward my goal.',
      },
      {
        key: 'e',
        text: 'I enjoy sharing my journey with others to inspire and connect meaningfully.',
      },
    ],
  },
  {
    id: 6,
    prompt:
      'If a lesson gets boring and you start losing interest, what do you do?',
    options: [
      {
        key: 'a',
        text: 'I would explain the lesson to someone else to make it more engaging.',
      },
      {
        key: 'b',
        text: 'I would get a study partner to help me stay focused and on track.',
      },
      {
        key: 'c',
        text: 'I would schedule short distractions or mini-tasks to stay refreshed and focused.',
      },
      {
        key: 'd',
        text: 'I would push myself to try something unexpected or creative related to the lesson.',
      },
      {
        key: 'e',
        text: 'I would connect the lesson to something meaningful for me to see it in a new way.',
      },
    ],
  },
  {
    id: 7,
    prompt: 'What type of assignment do you like best?',
    options: [
      {
        key: 'a',
        text: 'I enjoy assignments that are easy to organize and give me structure so I can check off each part as I go.',
      },
      {
        key: 'b',
        text: 'I enjoy assignments where teamwork and discussion make the work more interesting.',
      },
      {
        key: 'c',
        text: 'I like assignments that give me freedom to experiment and think outside the box.',
      },
      {
        key: 'd',
        text: 'I enjoy assignments where following the steps guarantees success.',
      },
      {
        key: 'e',
        text: 'I enjoy tasks that challenge me to think carefully and understand the underlying meaning.',
      },
    ],
  },
  {
    id: 8,
    prompt: 'What type of advice helps you the most?',
    options: [
      {
        key: 'a',
        text: 'Guidance that gives me a system I can apply consistently.',
      },
      {
        key: 'b',
        text: 'Suggestions that spark new ideas without telling me exactly what to do.',
      },
      {
        key: 'c',
        text: 'Feedback that shows me exactly where I stand and what to adjust.',
      },
      {
        key: 'd',
        text: 'Insights that help me connect the dots myself.',
      },
      {
        key: 'e',
        text: 'Feedback that challenges my thinking and invites conversation.',
      },
    ],
  },
];
